import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  input,
  output,
} from '@angular/core';
import {
  CbButtonModule,
  CbIconModule,
  CbItemsShownAdjustorModule,
  CbItemsShownIndicatorModule,
  CbPageJumperModule,
  CbTextLinkModule,
} from '@chubb/ui-components';
import { CbPaginationNavModule } from '@chubb/ui-components/cb-pagination-nav';
import { CbTableSortModule } from '@chubb/ui-components/cb-table';
import { DatePicker } from 'primeng/datepicker';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { PolicySummary } from '../../../interfaces/policy-summary.model';
import { formatCurrency } from '../../../shared/utils/formatting';

@Component({
  selector: 'app-policy-summary',
  imports: [
    CommonModule,
    CbTableSortModule,
    TableModule,
    CbIconModule,
    CbPaginationNavModule,
    CbPageJumperModule,
    CbItemsShownIndicatorModule,
    CbItemsShownAdjustorModule,
    CbButtonModule,
    CbTextLinkModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './policy-summary.component.html',
  styleUrl: './policy-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicySummaryComponent implements AfterViewInit {
  rawPolicySummaries = input.required<PolicySummary[]>();
  policySummaries = computed(() =>
    this.rawPolicySummaries().map(policy => ({
      ...policy,
      updatedDate: policy.updatedDate ? new Date(policy.updatedDate) : policy.updatedDate,
    })),
  );
  variantDownloadQueue = input.required<string[]>();
  navigateToBaseQFA = output<void>();
  downloadVariantQuote = output<string>();

  isTableView = true;
  isMobile: boolean = false;

  ngAfterViewInit(): void {
    DatePicker.prototype.getDateFormat = () => 'dd/mm/yy';
    this._checkIsMobile();
  }

  @HostListener('window:resize', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  onResize(event: any) {
    this._checkIsMobile();
  }

  private _checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
  }

  formatPremium(val: number | null | undefined): string {
    if (val) {
      return formatCurrency(val / 100);
    }
    return 'n/a';
  }

  addNewQFA() {
    this.navigateToBaseQFA.emit();
  }

  toggleResultsView() {
    this.isTableView = !this.isTableView;
  }

  downloadQuote(policy: string) {
    this.downloadVariantQuote.emit(policy);
  }
}
